module.exports = __webpack_public_path__ + "img/12.e15ea9a0.png";